import RecommendationsListHorizontal from '../../../../../pages/vip/features/recommendations/list-horizontal';

export default RecommendationsListHorizontal;
